// Service Request List 列表页（配置驱动）的 topFilter 行为
// 对应 CompanyWebUIConfig.xml 中 <section name="ServiceRequestList">
// 过滤器：Status 下拉(serviceRequestStatusId) + Date Created 范围(dateStart/dateEnd)
import { message } from 'antd';
import { config } from 'util/config';

// 过滤器变化：把值写入 searchParameter 后刷新列表
// 与 Lga 等页不同：这里不要求所有过滤器都已选（日期范围可空），随时变随时刷
export function getSectionDataByDefault({ parameter, sectionComponent, uie } = {}) {
  // DatePicker 的 onChange 传来的是 moment 对象，统一格式化成 yyyy-MM-dd 给后端；清空时为 null
  let value = parameter;
  if (value && typeof value.format === 'function') {
    value = value.format('YYYY-MM-DD');
  }

  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter; // 控件显示值保留原始（moment）
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = value;           // 传给后端的查询值（格式化后）
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  reloadFromFirstPage(sectionComponent);
}

// DatePicker「Clear」按钮：清掉对应日期过滤后刷新（Clear 会调 'clear' + uie.source，即 clearDateStart / clearDateEnd）
export function clearDateStart({ sectionComponent } = {}) {
  clearDateFilter(sectionComponent, 'DateStart');
}
export function clearDateEnd({ sectionComponent } = {}) {
  clearDateFilter(sectionComponent, 'DateEnd');
}

function clearDateFilter(sectionComponent, source) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[source] = undefined;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[source] = null;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  reloadFromFirstPage(sectionComponent);
}

// 底部 Email 按钮：取勾选的 Service Request，打开发信弹窗（收件人/正文在后端发信时逐条解析+mailmerge）
export function emailServiceRequests({ sectionComponent } = {}) {
  const selectedRowKeys = sectionComponent.child.current?.state.selectedRowKeys || [];
  if (selectedRowKeys.length === 0) {
    message.warning('You must select at least one service request.');
    return;
  }
  // 把选中的 service_request id 交给发信弹窗
  sectionComponent.setState({ sendEmailShow: true, selectedServiceRequestIdList: selectedRowKeys });
}

// 回到第 1 页再取数
function reloadFromFirstPage(sectionComponent) {
  setTimeout(() => {
    if (sectionComponent.child.current) {
      sectionComponent.child.current.setState(
        { pagination: { ...sectionComponent.child.current.state.pagination, current: 1 } },
        () => sectionComponent.getSectionDataByDefault()
      );
    }
  }, config.setTimeoutMilliSecond);
}
